<template>
  <div
    class="ws-row"
    :class="{center:isCenter,right:isRight,blue}"
    :style="{'max-width': maxWidth}"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "WsRow",
  props: {
    isCenter: {
      type: Boolean,
      default: false,
    },
    isRight: {
      type: Boolean,
    },
    blue: {
      type: Boolean,
    },
    maxWidth: {
      type: String,
    }
  },
};
</script>